import Button from 'components/Button'
import React, { useEffect } from 'react'
import useProduct from 'store/SingleProductProvider'
import {
  ProductVersions,
  ProductVersionsContainer,
} from './MainInfo/MainInfo.style'
import { HexColorButtonInner } from '../../Button/Button.style'

export default function ProductVariants() {
  const { product, chosenVariants, variantChosen } = useProduct()
  const variants = product.variants

  const checkStocks = () => {
    if (!Array.isArray(variants)) return null

    for (const variant of variants) {
      const variantCopy = variant
      for (const value of variant.values) {
        const valueCopy = value
        let url = `https://api.citrus.ge/api/dressup/stock?sku=${product.sku}&attributes[${variantCopy.attribute_id}]=${valueCopy.id}`
        for (const variantId in chosenVariants) {
          // TODO unselect current value variant if not in stock
          const variantValue = chosenVariants[variantId]

          if (variantId === variantCopy.attribute_id) {
            continue
          }
          url += `&attributes[${variantId}]=${variantValue.id}`
        }

        fetch(url)
          .then(res => res.json())
          .then(res => {
            const elem = document.getElementById(
              `${variantCopy.attribute_id}:${valueCopy.id}`
            )
            if (res.stock <= 0) {
              elem.setAttribute('disabled', 'true')
            } else {
              elem.removeAttribute('disabled')
            }
          })
      }
    }
  }

  useEffect(checkStocks, [])

  return (
    <ProductVersionsContainer>
      {(variants || []).map(variant => {
        return (
          <div key={variant.attribute_id}>
            <h4>{variant.name}:</h4>
            <ProductVersions>
              {variant.values.map(val => {
                const selected =
                  val.id === chosenVariants[variant.attribute_id]?.id

                if (String(variant.attribute_id) === '58') {
                  return (
                    <Button
                      key={val.id}
                      id={`${variant.attribute_id}:${val.id}`}
                      color={'hex'}
                      onClick={() => {
                        variantChosen(variant, val)
                        checkStocks()
                      }}
                      className={selected ? 'active' : ''}
                    >
                      <HexColorButtonInner
                        id={`${variant.attribute_id}:${val.id}inner`}
                        backgroundColor={`${val.value} `}
                      />
                    </Button>
                  )
                } else {
                  return (
                    <Button
                      key={val.id}
                      id={`${variant.attribute_id}:${val.id}`}
                      color={'grey'}
                      onClick={() => {
                        variantChosen(variant, val)
                        checkStocks()
                      }}
                      className={selected ? 'active' : ''}
                    >
                      {val.value}
                    </Button>
                  )
                }
              })}
            </ProductVersions>
          </div>
        )
      })}
    </ProductVersionsContainer>
  )
}
